import {
  HHToggleButton,
  HHToggleButtonGroup,
} from '@hinge-health/react-component-library';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../constants/strings/routes';

export type FeeScheduleView = 'client' | 'partnership' | 'esi' | 'cvs';

export interface FeeScheduleViewToggleProps {
  currentView: FeeScheduleView;
}

export const FeeScheduleViewToggle = ({
  currentView,
}: FeeScheduleViewToggleProps): JSX.Element => {
  const navigate = useNavigate();

  const handleClientClick = (): void => {
    navigate(`${routes.billing.home}${routes.billing.clientFeeSchedules}`);
  };

  const handlePartnershipClick = (): void => {
    navigate(`${routes.billing.home}${routes.billing.partnershipFeeSchedules}`);
  };

  const handleEsiClick = (): void => {
    navigate(`${routes.billing.home}${routes.billing.esiFeeSchedules}`);
  };

  const handleCvsClick = (): void => {
    navigate(`${routes.billing.home}${routes.billing.cvsFeeSchedules}`);
  };

  return (
    <HHToggleButtonGroup
      size="small"
      aria-label="fee schedule view toggle"
      sx={{ height: '40px' }}
    >
      <HHToggleButton
        hhVariant="variant-bypass"
        selected={currentView === 'client'}
        value="client"
        onClick={(_e): void => handleClientClick()}
        aria-label="client fee schedules view"
        data-testid="client-fee-schedules-toggle"
        sx={{ borderRadius: '4px 0 0 4px', textTransform: 'none' }}
      >
        Clients
      </HHToggleButton>
      <HHToggleButton
        hhVariant="variant-bypass"
        selected={currentView === 'partnership'}
        value="partnership"
        onClick={(_e): void => handlePartnershipClick()}
        aria-label="partnership fee schedules view"
        data-testid="partnership-fee-schedules-toggle"
        sx={{ borderRadius: 0, textTransform: 'none' }}
      >
        Partnerships
      </HHToggleButton>
      <HHToggleButton
        hhVariant="variant-bypass"
        selected={currentView === 'esi'}
        value="esi"
        onClick={(_e): void => handleEsiClick()}
        aria-label="esi fee schedules view"
        data-testid="esi-fee-schedules-toggle"
        sx={{ borderRadius: 0, textTransform: 'none' }}
      >
        ESI UPCs
      </HHToggleButton>
      <HHToggleButton
        hhVariant="variant-bypass"
        selected={currentView === 'cvs'}
        value="cvs"
        onClick={(_e): void => handleCvsClick()}
        aria-label="cvs fee schedules view"
        data-testid="cvs-fee-schedules-toggle"
        sx={{ borderRadius: '0 4px 4px 0', textTransform: 'none' }}
      >
        CVS UPCs
      </HHToggleButton>
    </HHToggleButtonGroup>
  );
};
